import { ChevronLeft, ChevronRight } from 'lucide-react';

// Generic pagination footer used across admin tables (users, domains,
// activity). Renders nothing when there's only one page of results.
//
// Props:
//   page          — current 1-indexed page
//   totalPages    — total pages from the server
//   total         — total matching rows (used for "showing X–Y of Z")
//   pageSize      — items per page
//   onPageChange  — (newPage: number) => void
//   isFetching    — disables buttons while a fetch is in flight
export default function PaginationFooter({
  page,
  totalPages,
  total,
  pageSize,
  onPageChange,
  isFetching = false,
}) {
  if (!total || totalPages <= 1) return null;
  const start = (page - 1) * pageSize + 1;
  const end = Math.min(page * pageSize, total);
  return (
    <div className="mt-4 pt-3 border-t border-gray-100 flex items-center justify-between gap-3 flex-wrap text-sm">
      <span className="text-ink-500">
        Showing <span className="font-medium text-ink-700">{start}</span>–
        <span className="font-medium text-ink-700">{end}</span> of{' '}
        <span className="font-medium text-ink-700">{total}</span>
      </span>
      <div className="flex items-center gap-2">
        <button
          type="button"
          className="btn-secondary text-xs disabled:opacity-40 disabled:cursor-not-allowed"
          disabled={page <= 1 || isFetching}
          onClick={() => onPageChange(Math.max(page - 1, 1))}
        >
          <ChevronLeft className="w-3 h-3" /> Prev
        </button>
        <span className="text-ink-500 text-xs px-1">
          Page <span className="font-medium text-ink-700">{page}</span> of{' '}
          <span className="font-medium text-ink-700">{totalPages}</span>
        </span>
        <button
          type="button"
          className="btn-secondary text-xs disabled:opacity-40 disabled:cursor-not-allowed"
          disabled={page >= totalPages || isFetching}
          onClick={() => onPageChange(Math.min(page + 1, totalPages))}
        >
          Next <ChevronRight className="w-3 h-3" />
        </button>
      </div>
    </div>
  );
}
